import React, { useState, useEffect, useRef } from "react";
import { BsCalendar2PlusFill } from "react-icons/bs";
import { FaApple, FaGoogle } from "react-icons/fa";
import { IoCopyOutline } from "react-icons/io5";
import "./AddToCalendar.css";

const BASE = "fmb.austinjamaat.org/calendar";

const AddToCalendar = ({ calendarKey }) => {
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const containerRef = useRef(null);

    const webcalUrl = `webcal://${BASE}/${calendarKey}.ics`;
    const httpsUrl = `https://${BASE}/${calendarKey}.ics`;
    const googleCalUrl = `https://www.google.com/calendar/render?cid=${encodeURIComponent(webcalUrl)}`;

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        if (open) document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [open]);

    const copyLink = async () => {
        await navigator.clipboard.writeText(httpsUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="add-to-cal-container" ref={containerRef}>
            <button
                className="add-to-cal-btn"
                onClick={() => setOpen((prev) => !prev)}
                aria-label="Add to calendar"
            >
                <BsCalendar2PlusFill />
                {!open && <span className="add-to-cal-tooltip">Import</span>}
            </button>
            {open && (
                <div className="add-to-cal-dropdown">
                    <a href={webcalUrl} title="Apple">
                        <FaApple />
                    </a>
                    <a href={googleCalUrl} target="_blank" rel="noopener noreferrer" title="Google">
                        <FaGoogle />
                    </a>
                    <button className="add-to-cal-copy-btn" onClick={copyLink} title={copied ? "Copied!" : "Copy"}>
                        <IoCopyOutline />
                    </button>
                </div>
            )}
        </div>
    );
};

export default AddToCalendar;
